import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { authAPI } from '../../services/api';

const ProfilePage = () => {
  const { user, loadProfile } = useAuth();
  const [form, setForm] = useState({ first_name: user?.first_name || '', last_name: user?.last_name || '', phone: user?.phone || '' });
  const [pwForm, setPwForm] = useState({ current_password: '', new_password: '' });
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleUpdate = async (e) => {
    e.preventDefault();
    try {
      await authAPI.updateProfile(form);
      await loadProfile();
      setMessage('Profil mis à jour');
      setError('');
    } catch (err) {
      setError(err.response?.data?.error || 'Erreur');
    }
  };

  const handlePassword = async (e) => {
    e.preventDefault();
    try {
      await authAPI.changePassword(pwForm);
      setPwForm({ current_password: '', new_password: '' });
      setMessage('Mot de passe modifié');
      setError('');
    } catch (err) {
      setError(err.response?.data?.error || 'Erreur');
    }
  };

  return (
    <div>
      <div className="page-header"><h1>Mon Profil</h1></div>

      {message && <div className="alert alert-success">{message}</div>}
      {error && <div className="alert alert-error">{error}</div>}

      <div className="grid-2">
        <div className="card">
          <div className="card-header"><h2>Informations personnelles</h2></div>
          <div className="card-body">
            <form onSubmit={handleUpdate}>
              <div className="form-group">
                <label>Prénom</label>
                <input className="form-control" value={form.first_name} onChange={e => setForm({ ...form, first_name: e.target.value })} />
              </div>
              <div className="form-group">
                <label>Nom</label>
                <input className="form-control" value={form.last_name} onChange={e => setForm({ ...form, last_name: e.target.value })} />
              </div>
              <div className="form-group">
                <label>Téléphone</label>
                <input className="form-control" value={form.phone} onChange={e => setForm({ ...form, phone: e.target.value })} />
              </div>
              <div className="form-group">
                <label>Email</label>
                <input className="form-control" value={user?.email || ''} disabled />
              </div>
              <button type="submit" className="btn btn-primary">Enregistrer</button>
            </form>
          </div>
        </div>

        <div className="card">
          <div className="card-header"><h2>Changer le mot de passe</h2></div>
          <div className="card-body">
            <form onSubmit={handlePassword}>
              <div className="form-group">
                <label>Mot de passe actuel</label>
                <input type="password" className="form-control" value={pwForm.current_password} onChange={e => setPwForm({ ...pwForm, current_password: e.target.value })} required />
              </div>
              <div className="form-group">
                <label>Nouveau mot de passe</label>
                <input type="password" className="form-control" value={pwForm.new_password} onChange={e => setPwForm({ ...pwForm, new_password: e.target.value })} minLength={6} required />
              </div>
              <button type="submit" className="btn btn-primary">Modifier</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfilePage;
